import { Shield, Truck, CreditCard, Heart, BookOpen, Star } from 'lucide-react';

export function TrustSection() {
  return (
    <section className="py-16 sm:py-24 bg-black/50 px-4 sm:px-6">
      <div className="container mx-auto max-w-7xl">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-12 max-w-5xl mx-auto">
          <div className="text-center group">
            <div className="bg-gradient-to-br from-red-500/10 to-red-500/5 w-16 h-16 sm:w-20 sm:h-20 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform border border-red-500/20">
              <Shield className="w-8 h-8 sm:w-10 sm:h-10 text-red-500" />
            </div>
            <h3 className="text-lg sm:text-xl font-bold mb-3">Garanție 30 zile</h3>
            <p className="text-gray-400 text-sm sm:text-base">Returnare garantată 100% fără întrebări</p>
          </div>

          <div className="text-center group">
            <div className="bg-gradient-to-br from-red-500/10 to-red-500/5 w-16 h-16 sm:w-20 sm:h-20 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform border border-red-500/20">
              <Heart className="w-8 h-8 sm:w-10 sm:h-10 text-red-500" />
            </div>
            <h3 className="text-lg sm:text-xl font-bold mb-3">Experiență Reală</h3>
            <p className="text-gray-400 text-sm sm:text-base">Scrisă din experiență personală</p>
          </div>

          <div className="text-center group">
            <div className="bg-gradient-to-br from-red-500/10 to-red-500/5 w-16 h-16 sm:w-20 sm:h-20 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform border border-red-500/20">
              <BookOpen className="w-8 h-8 sm:w-10 sm:h-10 text-red-500" />
            </div>
            <h3 className="text-lg sm:text-xl font-bold mb-3">Kit Complet</h3>
            <p className="text-gray-400 text-sm sm:text-base">27 exerciții + 5 tehnici de urgență</p>
          </div>

          <div className="text-center group">
            <div className="bg-gradient-to-br from-red-500/10 to-red-500/5 w-16 h-16 sm:w-20 sm:h-20 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform border border-red-500/20">
              <Truck className="w-8 h-8 sm:w-10 sm:h-10 text-red-500" />
            </div>
            <h3 className="text-lg sm:text-xl font-bold mb-3">Livrare Rapidă</h3>
            <p className="text-gray-400 text-sm sm:text-base">24-48h oriunde în țară</p>
          </div>

          <div className="text-center group">
            <div className="bg-gradient-to-br from-red-500/10 to-red-500/5 w-16 h-16 sm:w-20 sm:h-20 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform border border-red-500/20">
              <CreditCard className="w-8 h-8 sm:w-10 sm:h-10 text-red-500" />
            </div>
            <h3 className="text-lg sm:text-xl font-bold mb-3">Plată Sigură</h3>
            <p className="text-gray-400 text-sm sm:text-base">Card sau ramburs, 100% securizat</p>
          </div>

          <div className="text-center group">
            <div className="bg-gradient-to-br from-red-500/10 to-red-500/5 w-16 h-16 sm:w-20 sm:h-20 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform border border-red-500/20">
              <Star className="w-8 h-8 sm:w-10 sm:h-10 text-red-500" />
            </div>
            <h3 className="text-lg sm:text-xl font-bold mb-3">Rezultate Dovedite</h3>
            <p className="text-gray-400 text-sm sm:text-base">98% rată de succes la cititori</p>
          </div>
        </div>
      </div>
    </section>
  );
}
